import React from "react";

export default function Tab() {
  return <span>&tab;</span>;
}
